import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { LoginWithVerificationCodeRequest } from "@obg/ngx.core";

import { ChallengeDetails, SuspiciousLoginPinRequest } from "./suspicious-login.model";

export const ACTION_PREFIX = "[Suspicious Login]";

export const SUSPICIOUS_LOGIN_ACTION_TYPE = {
	setCommunicationChannels: `${ACTION_PREFIX} Set Channels ${SYNC_SUFFIX}`,
	clearCommunicationChannels: `${ACTION_PREFIX} Clear Channels ${SYNC_SUFFIX}`,

	requestPin: `${ACTION_PREFIX} Request PIN`,
	requestPinSuccess: `${ACTION_PREFIX} Request PIN Success`,
	requestPinFail: `${ACTION_PREFIX} Request PIN Fail`,

	resetPin: `${ACTION_PREFIX} Reset PIN  ${SYNC_SUFFIX}`,
	verifyPin: `${ACTION_PREFIX} Verify PIN ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class SuspiciousLoginAction {
	setCommunicationChannels(payload: ChallengeDetails): ActionWithPayload {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.setCommunicationChannels,
			payload,
		};
	}

	requestPin(payload: SuspiciousLoginPinRequest): ActionWithPayload {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.requestPin,
			payload,
		};
	}

	requestPinSuccess(): Action {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.requestPinSuccess,
		};
	}

	requestPinFail(): Action {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.requestPinFail,
		};
	}

	verifyPin(payload: LoginWithVerificationCodeRequest): ActionWithPayload {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.verifyPin,
			payload,
		};
	}

	resetPin(): Action {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.resetPin,
		};
	}

	clearCommunicationChannels(): Action {
		return {
			type: SUSPICIOUS_LOGIN_ACTION_TYPE.clearCommunicationChannels,
		};
	}
}
